import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { SNELKNOP_CATALOGUS, SNELKNOP_STANDAARD } from './snelknoppenCatalogus';
import SnelknoppenEditor from './SnelknoppenEditor';

export default function MonteursAppInstellingen() {
  const [waarde, setWaarde] = useState(SNELKNOP_STANDAARD);
  const [heeftBedrijf, setHeeftBedrijf] = useState(false);
  const [melding, setMelding] = useState('');
  const [laden, setLaden] = useState(true);

  useEffect(() => {
    api.get('/app-startscherm').then(r => {
      if (r.data.bedrijf) { setWaarde(r.data.bedrijf); setHeeftBedrijf(true); }
    }).catch(() => {}).finally(() => setLaden(false));
  }, []);

  const bewaar = async (reset) => {
    setMelding('');
    try {
      const r = await api.put('/app-startscherm/bedrijf', reset ? { reset: true } : waarde);
      setHeeftBedrijf(!!r.data.bedrijf);
      if (reset) setWaarde(SNELKNOP_STANDAARD);
      setMelding(reset ? '✓ Teruggezet naar WOMsys-standaard' : '✓ Opgeslagen — geldt voor monteurs zonder eigen indeling');
    } catch (e) { setMelding('⚠ ' + (e.response?.data?.message || 'Opslaan mislukt')); }
  };

  if (laden) return <div style={{ padding: 20 }}>Laden…</div>;
  return (
    <div className="settings-section" style={{ maxWidth: 620 }}>
      <h2 style={{ marginTop: 0 }}>📱 Monteurs-app — startscherm</h2>
      <p style={{ color: '#64748b', fontSize: 14 }}>
        De snelknoppen die monteurs standaard op hun startscherm zien. Monteurs kunnen dit zelf aanpassen
        (Meer → Startscherm). Knoppen waar iemand geen recht op heeft, worden automatisch verborgen.
      </p>
      <SnelknoppenEditor catalogus={SNELKNOP_CATALOGUS} waarde={waarde} onChange={setWaarde} />
      <div style={{ display: 'flex', gap: 8, marginTop: 18 }}>
        <button className="btn btn-primary" onClick={() => bewaar(false)}>Opslaan als bedrijfsstandaard</button>
        {heeftBedrijf && <button className="btn btn-secondary" onClick={() => bewaar(true)}>Terug naar WOMsys-standaard</button>}
      </div>
      {melding && <div style={{ marginTop: 10, fontSize: 14 }}>{melding}</div>}
    </div>
  );
}
